import { render, staticRenderFns } from "./OnlineApplicationNotification.vue?vue&type=template&id=735510ba&scoped=true&lang=pug"
import script from "./OnlineApplicationNotification.vue?vue&type=script&lang=ts"
export * from "./OnlineApplicationNotification.vue?vue&type=script&lang=ts"
import style0 from "./OnlineApplicationNotification.vue?vue&type=style&index=0&id=735510ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735510ba",
  null
  
)

/* custom blocks */
import block0 from "./OnlineApplicationNotification.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FTemplate%2Fviews%2FOnlineApplication%2FTemplateOnlineApplication%2FOnlineApplicationNotification.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports